import React from 'react';
import PowerPlantOfferEnhanced from './PowerPlantOfferEnhanced';

const PowerPlantBuilderIntegration = () => {
  return (
    <div className="power-plant-builder-wrapper">
      {/* Power Plant Offer Enhanced Component with save/load functionality */}
      <PowerPlantOfferEnhanced />
    </div>
  );
};

export default PowerPlantBuilderIntegration; 